export const countryCodeJp = "+81";

export const toFirebaseFormat = (phoneNumber: string): string => {
  // Strip separators from the UI input (e.g. "090-1234-5678") and drop the
  // leading national "0" so the result is strict E.164 ("+819012345678").
  // Keeping the hyphens would yield "+8190-1234-5678", which the backend
  // rate-limit gate can reject as an invalid phone number.
  const nationalDigits = phoneNumber.replace(/\D/g, "").replace(/^0/, "");
  return countryCodeJp + nationalDigits;
};
